export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_34-c4153e9038b439d4e12bb85ba0f8abe7.jpg";